/**
 * MenuItemType
 *
 * Identifies the row tapped inside the expanded home top bar menu
 * (`HomeTopBarBody`). The string values are used as React `key`s for the rendered
 * rows, so they must remain stable to avoid spurious remounts. Members are listed
 * in the order the rows render in the menu (PROFILE first, then PREMIUM_PACKAGES …);
 * keep this order aligned with the `menuItems` array in `HomeTopBarBody`.
 */

export enum MenuItemType {
  PROFILE = 'profile',
  PREMIUM_PACKAGES = 'premiumPackages',
  CAMPAIGNS = 'campaigns',
  IDEAS = 'ideas',
  FEEDBACK = 'feedback',
  THEME = 'theme',
  LANGUAGE = 'language',
  SHARE = 'share',
}
